export default {
  title: 'Objednávka služeb',
  loadError: 'Ceník se nepodařilo načíst. Zkuste to prosím znovu.',

  products: {
    heading: 'Vyberte jednu z variant',
    or: 'nebo',
    select: 'Vybrat',
    perYear: 'za rok',
    perPoll: 'za hlasování',
    withVat: 's DPH',
    withoutVat: 'bez DPH {{price}}',
    selected: 'Vybráno',
    pending: 'Čeká na platbu',
    subscription: {
      title: 'Kompletní služby',
      titleRenewal: 'Prodloužení kompletních služeb',
      subtitle: 'Roční licence pro celý dům',
      features: [
        'Neomezená hlasování per rollam',
        'Kontrola rejstříků – katastr, rejstřík SVJ, insolvence, DPH',
        'Úložiště dokumentů a zprávy vlastníkům',
        'Hlídač termínů, závady a podněty',
      ],
    },
    poll: {
      title: 'Jednorázové hlasování',
      subtitle: 'Když potřebujete jen jedno hlasování per rollam',
      features: ['Jedno hlasování s právně průkaznými výsledky', 'Platnost 12 měsíců od zaplacení'],
      quantity: 'Počet hlasování',
      decrease: 'Ubrat hlasování',
      increase: 'Přidat hlasování',
    },
  },

  billing: {
    heading: 'Objednává',
    companyId: 'IČO',
    taxId: 'DIČ',
    email: 'Doklady pošleme na',
    emailNote: 'a v kopii ostatním administrátorům domu',
    problem:
      'Fakturační údaje vašeho SVJ nejsou úplné, objednávku proto nejde odeslat. Napište nám prosím na pomoc@evlastnici.cz.',
  },

  recap: {
    heading: 'Rekapitulace',
    subscription: 'Kompletní služby na 12 měsíců',
    poll_one: '{{count}}× jednorázové hlasování',
    poll_few: '{{count}}× jednorázové hlasování',
    poll_other: '{{count}}× jednorázových hlasování',
    withoutVat: 'Cena bez DPH',
    vat: 'DPH {{rate}} %',
    total: 'Celkem k úhradě s DPH',
    // první / propadlá licence: platnost běží od přijetí platby, konkrétní datum předem neznáme
    validToNew: 'Licence platí 12 měsíců ode dne přijetí platby.',
    validToRenewal: 'Licence naváže na stávající (do {{current}}) a bude platit do {{date}}.',
    payment: 'Platba převodem na základě proforma faktury – údaje k platbě včetně QR kódu pošleme e-mailem.',
  },

  autoRenew: {
    label: 'Před koncem období mi automaticky pošlete upozornění a proforma fakturu na prodloužení',
  },

  openOrder: {
    title: 'Tuto službu už máte objednanou',
    text: 'Proforma fakturu jsme vám už poslali a čekáme na platbu. Novou objednávku proto není potřeba zakládat.',
    action: 'Zobrazit objednávku',
  },

  submit: 'Závazně objednat',
  submitError: 'Objednávku se nepodařilo odeslat. Zkuste to prosím znovu, nebo nám napište na pomoc@evlastnici.cz.',

  status: {
    title: 'Stav objednávky',
    notFound: 'Objednávku se nepodařilo načíst.',
    // stav `created` — platí bez ohledu na to, jestli Fakturoid odpoví za 2 s nebo až za hodinu
    pending: {
      title: 'Objednávku jsme přijali, děkujeme!',
      text: 'Jakmile vystavíme proforma fakturu, pošleme vám ji i s pokyny k platbě e-mailem na {{email}}.',
      hint: 'Obvykle to trvá jen pár sekund.',
      hintDelayed: 'Tuto stránku můžete zavřít, fakturu pošleme e-mailem.',
    },
    issued: {
      title: 'Děkujeme za objednávku!',
      text: 'Proforma fakturu č. {{number}} jsme odeslali na {{email}}. V e‑mailu najdete i QR platbu.',
      next: 'Po přijetí platby služby aktivujeme automaticky a pošleme vám daňový doklad.',
    },
    activated: {
      title: 'Zaplaceno – služby jsou aktivní',
      license: 'Licence platí do {{date}}.',
      poll: 'Objednaná hlasování máte připravená v sekci Hlasování.',
      taxDocumentPending: 'Daňový doklad vám pošleme e-mailem, jakmile ho vystavíme.',
    },
    // stav `failed` — pro zákazníka je to normální průběh, o ruční práci na naší straně nic neví
    failed: {
      title: 'Objednávku jsme přijali, děkujeme!',
      text: 'Teď je to na nás — připravíme proforma fakturu a pošleme vám ji e-mailem na {{email}}. Nemusíte dělat nic dalšího.',
    },
    cancelled: {
      title: 'Objednávka byla zrušena',
      text: 'Pokud máte o služby stále zájem, stačí založit novou objednávku.',
      action: 'Nová objednávka',
    },
    payment: {
      heading: 'Údaje k platbě',
      amount: 'Částka',
      account: 'Číslo účtu',
      variableSymbol: 'Variabilní symbol',
      dueOn: 'Splatnost',
      qr: 'Načtěte v bankovní aplikaci',
      qrAlt: 'QR kód pro platbu',
    },
    downloadProforma: 'Stáhnout proforma fakturu (PDF)',
    downloadTaxDocument: 'Stáhnout daňový doklad (PDF)',
    downloadError: 'Doklad se nepodařilo stáhnout.',
    backToApp: 'Přejít do aplikace',
  },
};
